module.exports = __webpack_public_path__ + "static/media/banff-25.3be9086a.jpg";